var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wh100 select-point"},[_c('div',{staticClass:"select-point-map"},[_c('div',{staticClass:"wh100",attrs:{"id":"selectpointMap"}})])])
}]

export { render, staticRenderFns }